/**
 * Registre des écrans chargés à la demande (code splitting).
 * Découpage technique par domaine : une seule entrée pour retrouver tous les chunks lazy.
 */
import { lazyWithRetry } from '../utils/lazyWithRetry';

// --- Tableau de bord (shell léger) ---
export const AdaptiveDashboard = lazyWithRetry(() => import('../components/Dashboard/AdaptiveDashboard'));

// --- Ressources humaines & catalogue salon ---
export const Employees = lazyWithRetry(() => import('./hr/employees/component'));
export const Payrolls = lazyWithRetry(() => import('./hr/payrolls/component'));
export const PerformanceIndicators = lazyWithRetry(() => import('./hr/performance-indicators/component'));
export const CatalogPacks = lazyWithRetry(() => import('./catalog-packs'));
export const Services = lazyWithRetry(() => import('./salon/services/component'));
export const ServiceCategories = lazyWithRetry(() => import('./salon/service-categories/component'));

// --- Clients & relationnel (fiche client, plans de paiement, marketing, messages) ---
export const Clients = lazyWithRetry(() => import('./clients/component'));
export const ClientDetail = lazyWithRetry(() => import('./clients/ClientDetail'));
export const PaymentPlans = lazyWithRetry(() => import('./clients/payment-plans/component'));
export const LoyaltyPass = lazyWithRetry(() => import('./loyalty-pass/component'));
export const Marketing = lazyWithRetry(() => import('./clients/marketing/component'));
export const CampaignDetail = lazyWithRetry(() => import('./clients/marketing/campaign-detail'));
export const MessagesClients = lazyWithRetry(() => import('./clients/messages-clients/component'));

// --- Inventaire ---
export const Categories = lazyWithRetry(() => import('./inventory/categories/component'));
export const Products = lazyWithRetry(() => import('./inventory/products/component'));
export const PackagingUnits = lazyWithRetry(() => import('./inventory/packaging-units/component'));
export const InventoryLosses = lazyWithRetry(() => import('./inventory/losses/component'));
export const InvoicingSettings = lazyWithRetry(() => import('./settings/invoicing/component'));
export const NotificationsSettings = lazyWithRetry(
  () => import('./settings/notifications/component')
);
export const SiteStatsPage = lazyWithRetry(() => import('./settings/site-stats/component'));
export const SettingsHub = lazyWithRetry(() => import('./settings/hub/component'));
export const StockMovements = lazyWithRetry(() => import('./inventory/stock-movements/component'));
export const ExternalDispatches = lazyWithRetry(() => import('./inventory/external-dispatches/component'));
export const ExternalDestinations = lazyWithRetry(() => import('./inventory/external-destinations/component'));
export const InventoryDashboard = lazyWithRetry(() => import('./inventory/dashboard/component'));
export const InventoryAudit = lazyWithRetry(() => import('./inventory/audit/component'));
export const InventoryAuditSession = lazyWithRetry(() => import('./inventory/audit-session/component'));
export const InventoryCountingInterface = lazyWithRetry(() => import('./inventory/counting-interface/component'));
export const InventoryAuditReports = lazyWithRetry(() => import('./inventory/audit-reports/component'));

// --- Fabrication ---
export const ManufacturingOrders = lazyWithRetry(() => import('./manufacturing/orders/component'));

// --- Fournisseurs ---
export const Suppliers = lazyWithRetry(() => import('./suppliers/registry/component'));
export const Deliveries = lazyWithRetry(() => import('./suppliers/deliveries/component'));

// --- Achats & dépenses (menu « Achats & Dépenses », hors compta pure) ---
export const Expenses = lazyWithRetry(() => import('./purchases/expenses/component'));
export const ExpenseNotes = lazyWithRetry(() => import('./purchases/expense-notes/component'));
export const ExpenseCategories = lazyWithRetry(() => import('./purchases/expense-categories/component'));

// --- Point de vente ---
export const TransactionPage = lazyWithRetry(() => import('./pos/transaction/component'));
export const PrestationsHistory = lazyWithRetry(() => import('./pos/prestations-history/component'));
export const SalesHistory = lazyWithRetry(() => import('./pos/sales-history/component'));
export const CashReports = lazyWithRetry(() => import('./pos/cash-reports/component'));

// --- Landings & promo ---
export const PromoLanding = lazyWithRetry(() => import('./promo-landing/component'));
export const CustomerLanding = lazyWithRetry(() => import('./customer-landing/component'));
export const InstitutLeNidDoux = lazyWithRetry(() => import('./landing/InstitutLeNidDoux'));
export const AppLaunchLanding = lazyWithRetry(() => import('./landing/AppLaunchLanding'));
export const PickupPublicLayout = lazyWithRetry(() => import('./pickup/public/PickupPublicLayout'));
export const PickupHomePage = lazyWithRetry(() => import('./pickup/public/pages/PickupHomePage'));
export const PickupFindPage = lazyWithRetry(() => import('./pickup/public/pages/PickupFindPage'));
export const PickupTrackPage = lazyWithRetry(() => import('./pickup/public/pages/PickupTrackPage'));
export const PickupJoinPage = lazyWithRetry(() => import('./pickup/public/pages/PickupJoinPage'));
export const PickupDirectPage = lazyWithRetry(() => import('./pickup/public/pages/PickupDirectPage'));
export const PickupInbox = lazyWithRetry(() => import('./pickup/inbox/component'));
export const PickupSettings = lazyWithRetry(() => import('./pickup/settings/component'));
export const PromoResolver = lazyWithRetry(() => import('./promo-resolver/component'));

// --- Rendez-vous (calendrier + demandes) ---
export const Appointments = lazyWithRetry(() => import('./appointments/component'));
export const AppointmentRequests = lazyWithRetry(() => import('./appointments/appointment-requests/component'));

// --- Comptabilité (TVA, journaux, tableau de bord comptable) ---
export const AccountingDashboard = lazyWithRetry(() => import('./accounting/dashboard/component'));
export const AccountingJournals = lazyWithRetry(() => import('./accounting/journals/component'));
export const TaxReturns = lazyWithRetry(() => import('./accounting/tax-returns/component'));

// --- Paramètres & sécurité ---
export const RoleProfiles = lazyWithRetry(() => import('./role-profiles/component'));
export const MyAccount = lazyWithRetry(() => import('./my-account/component'));
export const MyPayment = lazyWithRetry(() => import('./my-payment/component'));
export const Pipelines = lazyWithRetry(() => import('./activity/pipeline/component'));

// --- Référents ---
export const Referents = lazyWithRetry(() => import('./referents/component'));
export const ReferentDetail = lazyWithRetry(() => import('./referents/referent-detail'));

// --- Activité commerciale ---
export const ActivityReports = lazyWithRetry(() => import('./activity/reports/component'));
export const Opportunities = lazyWithRetry(() => import('./activity/opportunities/component'));
export const ClientTypes = lazyWithRetry(() => import('./activity/client-types/component'));
export const ActivityTypes = lazyWithRetry(() => import('./activity/activity-types/component'));
export const OpportunityCategories = lazyWithRetry(() => import('./activity/opportunity-categories/component'));

// --- Support / Aide ---
export const HelpPage = lazyWithRetry(() => import('./support/help/component'));
export const HelpTicketPage = lazyWithRetry(() => import('./support/help/ticket'));
export const SupportInboxPage = lazyWithRetry(() => import('./support/inbox/component'));
export const SupportInboxTicketPage = lazyWithRetry(() => import('./support/inbox/ticket'));
